import styled from 'styled-components';
import { radius, shadow, colorCSS } from '../../styles';
export const Section = styled.section `
  padding: 3rem 0;
`;
export const Template = styled.a `
  border-radius: ${radius['small']};
  box-shadow: ${shadow.normal};
  color: inherit;
  display: block;
  height: 100%;
  overflow: hidden;
  text-align: left;
  text-decoration: none;
  &:hover,
  &:focus {
    box-shadow: ${shadow.dark};
    outline: none;
    color: inherit;
  }
`;
export const TemplateHero = styled.div `
  height: 100px;
  ${({ background }) => background && `background: ${background};`};
`;
export const TemplateAvatar = styled.div `
  background-color: ${colorCSS('N0')};
  background-image: url(${({ image }) => image.url});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  border-color: ${colorCSS('N0')};
  border-style: solid;
  border-width: ${({ padding = false }) => (padding ? `8px` : `3px`)};
  border-radius: ${radius['small']};
  height: 3rem;
  left: 1rem;
  position: absolute;
  top: -1.5rem;
  width: 3rem;
`;
export const TemplateContent = styled.div `
  padding: 2rem 1rem;
  position: relative;
  h3 {
    margin: 0;
  }
  div {
    font-size: 1rem;
    margin: 0.5rem 0 0;
    &.muted {
      color: ${colorCSS('N300')};
    }
    p {
      margin: 0 !important;
    }
  }
`;
//# sourceMappingURL=UiTemplateGallery.styles.js.map